import { JSX, ComponentChild, h } from 'preact'
import Icon from '../../preact-components/assets'
import classNames from 'classnames'
import { LoadingSpinner } from './LoadingSpinner'

export type MessageTypes = 'info' | 'success' | 'warning' | 'danger' | 'loading'

interface Props {
  text?: string | ComponentChild
  title?: string | JSX.Element
  icon?: JSX.Element
  variant?: MessageTypes
  children?: JSX.Element
  fullWidth?: boolean
  hideIcon?: boolean
}
type IconType = 'info' | 'answer' | 'warning' | 'loadingSpinner'
type MessageVariantIconTypeMap = Record<MessageTypes, IconType>
const variantTypeToIconTypeMapping: MessageVariantIconTypeMap = {
  info: 'info',
  success: 'answer',
  warning: 'warning',
  danger: 'warning',
  loading: 'loadingSpinner'
}

export const Message = ({ text, variant = 'info', title, children, fullWidth, hideIcon = false, icon }: Props) => {
  const baseClass = 'panel-form-information'
  const className = classNames(
    baseClass,
    variant ? `${baseClass}--${variant}` : `${baseClass}--secondary`,
    fullWidth && `${baseClass}--fullWidth`
  )

  const hasChildren = Array(children).toString() !== ''
  const defaultIcon = icon ?? (
    <Icon
      icon={variantTypeToIconTypeMapping[variant]}
      width={20}
      height={20}
      customClass={`icon-${variantTypeToIconTypeMapping[variant]}`}
    />
  )

  return (
    <div className={className}>
      {!hideIcon && (
        <div className='panel-form-information__icon-box'>
          {variant === 'loading' ? <LoadingSpinner width={20} height={20} /> : defaultIcon}
        </div>
      )}
      <div>
        {title ? (
          <h4 className='panel-form-information__title'>
            <strong>{title}</strong>
          </h4>
        ) : (
          ''
        )}
        {hasChildren ? children : <div className='panel-form-text'>{text}</div>}
      </div>
    </div>
  )
}
